// 화면별 도움말(?) 콘텐츠 — HelpPanel.jsx가 현재 라우트(pathname)와 화면 언어(ko/en)에 맞는
// 항목을 찾아 보여준다.
// 2026-09: "각 화면에 ? 아이콘을 두고 사용자 매뉴얼을 즉시 참고할 수 있게 해달라"는 요청으로 신설.
// 2026-09: 영어 모드에서도 한글로 보인다는 피드백에 따라 각 항목에 en 버전을 추가.

// pathname을 라우트 키로 매핑한다. 배열 순서대로 검사하며, 더 구체적인(파라미터가 있는)
// 패턴을 먼저 두어야 한다 — 예: '/groups/:id/compare'가 '/groups/:id'보다 먼저.
const ROUTES = [
  { re: /^\/$/, key: 'dashboard' },
  { re: /^\/members(\/.*)?$/, key: 'members' },
  { re: /^\/attendance\/[^/]+$/, key: 'attendanceCheck' },
  { re: /^\/attendance\/?$/, key: 'attendance' },
  { re: /^\/groups\/[^/]+\/compare$/, key: 'groupCompareMove' },
  { re: /^\/groups\/[^/]+$/, key: 'groupDetail' },
  { re: /^\/groups\/?$/, key: 'groups' },
  { re: /^\/events\/[^/]+$/, key: 'eventDetail' },
  { re: /^\/events\/?$/, key: 'events' },
  { re: /^\/finance\/?$/, key: 'finance' },
  { re: /^\/photos(\/.*)?$/, key: 'photos' },
  { re: /^\/church-history\/?$/, key: 'churchHistory' },
  { re: /^\/pastoral\/?$/, key: 'pastoral' },
  { re: /^\/meeting-minutes\/?$/, key: 'meetingMinutes' },
  { re: /^\/committee\/equipment\/[^/]+$/, key: 'committeeEquipmentScan' },
  { re: /^\/committee\/location\/[^/]+\/[^/]+$/, key: 'committeeLocationScan' },
  { re: /^\/committee\/?$/, key: 'committee' },
  { re: /^\/prayer-relay\/?$/, key: 'prayerRelay' },
  { re: /^\/card-scan\/?$/, key: 'cardScan' },
  { re: /^\/checkin\/?$/, key: 'checkin' },
  { re: /^\/registrations\/?$/, key: 'pendingRegistrations' },
  { re: /^\/qrcode\/?$/, key: 'qrCode' },
  { re: /^\/settings\/codes\/?$/, key: 'codeSettings' },
  { re: /^\/settings\/users\/?$/, key: 'users' },
];

// 각 항목: { ko: { title, sections:[{heading, body}] }, en: { ... } }
const CONTENT = {
  dashboard: {
    ko: {
      title: '대시보드',
      sections: [
        { heading: '이 화면은 무엇인가요', body: '로그인 후 처음 보이는 화면입니다. 이번 달 전체 교인 수와 신규 등록, 최근 예배 출석률, 활성 그룹/셀 편입률, 다가오는 행사를 한눈에 요약해서 보여줍니다.' },
        { heading: '더 자세히 보기', body: '각 카드의 "전체 보기"를 누르면 교인 관리·출석 체크·주일학교/구역·행사/일정 화면으로 바로 이동합니다.' },
        { heading: '참고', body: '안수집사/제직 계정은 요약 화면까지만 볼 수 있고, "전체 보기"로 상세 화면까지 들어가지는 못합니다.' },
      ],
    },
    en: {
      title: 'Dashboard',
      sections: [
        { heading: 'What this screen is', body: 'This is the first screen you see after logging in. It summarizes this month at a glance: total members, new members this month, recent worship attendance rate, active groups/cell coverage, and upcoming events.' },
        { heading: 'See more', body: 'Click "View All" on any card to jump straight to Members, Attendance, Groups, or Events.' },
        { heading: 'Note', body: 'Deacon/elder (view-only) accounts can see this summary but cannot click through to the detailed screens.' },
      ],
    },
  },

  members: {
    ko: {
      title: '교인 관리',
      sections: [
        { heading: '이 화면은 무엇인가요', body: '교인 명단을 조회·등록·수정하는 화면입니다. 이름을 클릭하면 오른쪽(또는 아래)에 그 교인의 상세정보가 함께 열립니다.' },
        { heading: '등록 / 수정', body: '상단의 등록 버튼으로 새 교인을 등록하고, 목록의 "관리"로 기존 정보를 수정합니다. 이름(한글)은 필수이며, 법적 이름·세례일·구역·가족관계 등을 함께 입력할 수 있습니다.' },
        { heading: '상세정보', body: '이름을 클릭하면 기본정보, 연락처, 가족관계, 신앙 이력, 심방기록·기도제목(목회 관리 권한 필요), 출석 이력을 확인·수정할 수 있고, 성도가 스마트폰으로 쓰는 "포털 QR"도 여기서 발급합니다.' },
        { heading: '중복 교인 병합', body: '"중복 교인 병합"을 누르고 합칠 교인들을 선택한 뒤, 남길 교인 한 명을 고르면 나머지 교인의 헌금·출석·가족관계 기록이 모두 그 교인 앞으로 옮겨지고 나머지는 목록에서 사라집니다(기록 자체가 삭제되지는 않습니다).' },
        { heading: '엑셀 가져오기 / 내보내기', body: '양식을 내려받아 여러 교인을 한 번에 엑셀로 등록하거나, 현재 명단을 엑셀로 내보낼 수 있습니다.' },
      ],
    },
    en: {
      title: 'Members',
      sections: [
        { heading: 'What this screen is', body: 'Browse, register, and edit the member list. Clicking a name opens that member\'s detail panel alongside the list.' },
        { heading: 'Register / edit', body: 'Use the button at the top to register a new member, and "Manage" in the list to edit an existing one. The Korean name is required; you can also add a legal name, baptism date, district, and family relationships.' },
        { heading: 'Member detail', body: 'Clicking a name shows basic info, contacts, family relationships, faith history, pastoral visits & prayer requests (requires Pastoral access), and attendance history. This is also where you issue a member\'s "Portal QR" for their mobile portal.' },
        { heading: 'Merge duplicates', body: 'Click "Merge duplicate members," select the members to merge, then pick the one to keep — all giving, attendance, and family records from the others move to that member, and the others disappear from the list (their records are not deleted, just moved).' },
        { heading: 'Excel import / export', body: 'Download the template to bulk-register members from Excel, or export the current list to Excel.' },
      ],
    },
  },

  attendance: {
    ko: {
      title: '출석 체크',
      sections: [
        { heading: '이 화면은 무엇인가요', body: '예배 목록을 관리하고, 예배별 출석을 체크하는 화면입니다. "예배 목록"과 "구역별 출결 보고서" 두 탭으로 구성되어 있습니다.' },
        { heading: '예배 등록', body: '"+ 예배 등록"으로 예배명·종류(주일/수요/새벽/금요/특별)·날짜·시간·장소를 입력합니다. "행사/일정"에 등록된 예배는 여기에 자동으로 생성되며(자동 생성 배지 표시), 내용을 바꾸려면 행사/일정 쪽에서 수정해야 합니다.' },
        { heading: '출석 체크', body: '예배 카드를 클릭하면 교인별 출석 체크 화면으로 들어갑니다. 출석/지각/온라인 상태를 표시하고, 이름 검색과 출석 여부 필터를 쓸 수 있습니다. 예배 날짜가 지나기 전에는 체크할 수 없습니다.' },
        { heading: '대표 예배 지정', body: '여러 예배 중 "대표 예배(출석체크)"로 지정된 것이 있으면, 구역장이 개인 포털에서 예배를 따로 고르지 않고 출석만 표시해도 그 예배 기록으로 들어갑니다. 지정은 "행사/일정" 화면에서 바꿉니다.' },
        { heading: '구역별 출결 보고서', body: '두 번째 탭에서는 구역별로 집계된 출석 현황을 확인할 수 있습니다.' },
      ],
    },
    en: {
      title: 'Attendance',
      sections: [
        { heading: 'What this screen is', body: 'Manage the list of worship services and take attendance for each one. Two tabs: "Service List" and "District Attendance Report."' },
        { heading: 'Register a service', body: 'Use "+ Register Service" to enter the name, type (Sunday/Wednesday/dawn/Friday/special), date, time, and location. Services created from Events/Calendar appear here automatically (marked "auto-created") — edit them from Events instead.' },
        { heading: 'Taking attendance', body: 'Click a service card to open its attendance screen, where you mark each member Present / Late / Online. You can search by name and filter by attendance status. Attendance can\'t be taken before the service date has passed.' },
        { heading: 'Primary service', body: 'When a service is marked as the "primary service," a district leader\'s attendance entry in their personal portal is recorded against that service automatically, without having to pick one. Change which service is primary from the Events screen.' },
        { heading: 'District attendance report', body: 'The second tab shows attendance figures aggregated by district.' },
      ],
    },
  },

  groups: {
    ko: {
      title: '주일학교 / 구역',
      sections: [
        { heading: '이 화면은 무엇인가요', body: '주일학교 반, 구역, 셀 등 소그룹을 관리하는 화면입니다. 부서별로 그룹 카드가 묶여 표시됩니다.' },
        { heading: '그룹 등록 / 수정', body: '"+ 그룹 등록"으로 그룹 유형·이름(한/영)·지역·모임 요일/시간/장소·최대 인원·상태(활성/비활성)를 입력합니다.' },
        { heading: '드래그로 빠르게 옮기기', body: '그룹 카드를 상단 유형 탭 위에 놓으면 그 그룹의 유형이 바뀌고, 다른 그룹 카드 위에 놓으면 그 그룹 소속 학생 전원이 이동합니다(리더/부리더는 이동에서 제외됨).' },
        { heading: '그룹 이름 클릭 시(그룹 상세)', body: '하위 그룹 관리, 미배정 인원을 선택 또는 드래그로 배정, 그룹 간 개별/전원 이동(이동 이력 확인 및 되돌리기 가능), 리더·부리더·멤버 목록 및 이전 멤버 이력을 볼 수 있습니다.' },
        { heading: '나란히 보기(그룹 간 이동)', body: '두 그룹을 화면 좌우에 펼쳐 놓고, 멤버 카드를 길게 눌러 반대쪽 그룹으로 끌어다 놓으면 바로 이동됩니다.' },
      ],
    },
    en: {
      title: 'Groups',
      sections: [
        { heading: 'What this screen is', body: 'Manage small groups — Sunday school classes, districts, cells — organized here as cards grouped by department.' },
        { heading: 'Register / edit a group', body: 'Use "+ Register Group" to set the group type, name (Korean/English), region, meeting day/time/location, max members, and status (active/inactive).' },
        { heading: 'Drag to move quickly', body: 'Drop a group card onto a type tab at the top to change that group\'s type, or onto another group card to move every student in it there (leaders/co-leaders are excluded from the move).' },
        { heading: 'Clicking a group name (Group Detail)', body: 'Manage sub-groups, assign unassigned members (by selection or drag), move members between groups individually or all at once (with a move history you can undo), and view the leader/co-leader/member list along with past members.' },
        { heading: 'Side-by-side view (move between groups)', body: 'Open two groups side by side and long-press a member card to drag it to the other group — it moves immediately.' },
      ],
    },
  },

  groupDetail: {
    ko: {
      title: '그룹 상세',
      sections: [
        { heading: '이 화면은 무엇인가요', body: '주일학교/구역 화면에서 특정 그룹을 클릭했을 때 열리는 상세 화면입니다.' },
        { heading: '하위 그룹', body: '반/조 등 하위 그룹을 추가하고, 하위 그룹 카드에 마우스를 올리면 소속 인원을 미리 볼 수 있습니다.' },
        { heading: '미배정 인원 배정', body: '아직 어느 그룹에도 속하지 않은 인원을 체크로 선택해 일괄 배정하거나, 명단을 드래그해서 오른쪽 그룹에 놓아도 배정됩니다.' },
        { heading: '그룹 간 이동', body: '이동할 멤버를 선택(선택 안 하면 전원, 리더/부리더는 자동 제외)하고 검색으로 대상 그룹을 찾아 이동합니다. "이동 이력"에서 과거 이동 기록을 확인하고 "되돌리기"로 원래 그룹으로 복원할 수 있습니다.' },
        { heading: '멤버 목록', body: '리더/부리더/멤버 구분과 입원일이 표시되며, "제거"로 그룹에서 완전히 내보낼 수 있습니다(다른 그룹으로 옮기려면 제거 대신 "그룹 간 이동"을 사용하세요). 이탈한 이전 멤버 이력도 함께 조회됩니다.' },
      ],
    },
    en: {
      title: 'Group Detail',
      sections: [
        { heading: 'What this screen is', body: 'Opens when you click a specific group from the Groups screen.' },
        { heading: 'Sub-groups', body: 'Add sub-groups (e.g. classes), and hover over a sub-group card to preview its members.' },
        { heading: 'Assign unassigned members', body: 'Select unassigned members with checkboxes for bulk assignment, or drag a name onto a group on the right to assign it.' },
        { heading: 'Move between groups', body: 'Select the members to move (leave unselected to move everyone; leaders/co-leaders are always excluded), search for the target group, and move. "Move History" shows past moves, which you can undo.' },
        { heading: 'Member list', body: 'Shows leader/co-leader/member roles and join dates. "Remove" takes a member out of the group entirely (use "Move Between Groups" instead if you want to transfer them elsewhere). Past members who have left are also listed.' },
      ],
    },
  },

  groupCompareMove: {
    ko: {
      title: '그룹 간 이동 (나란히 보기)',
      sections: [
        { heading: '이 화면은 무엇인가요', body: '두 그룹을 화면 좌우에 나란히 펼쳐놓고, 멤버를 드래그해서 서로 옮기기 위한 화면입니다.' },
        { heading: '사용법', body: '좌/우 상단 버튼으로 비교할 그룹을 각각 선택합니다. 멤버 카드를 길게 눌러 반대쪽 그룹 영역으로 끌어다 놓으면 즉시 이동됩니다. "좌우 바꾸기"로 두 그룹의 위치를 바꿀 수 있습니다.' },
      ],
    },
    en: {
      title: 'Move Between Groups (Side by Side)',
      sections: [
        { heading: 'What this screen is', body: 'Shows two groups side by side so you can drag members between them.' },
        { heading: 'How to use it', body: 'Pick the group to compare on each side using the buttons at the top. Long-press a member card and drag it to the other side to move them instantly. Use "Swap Sides" to swap which group is on the left and right.' },
      ],
    },
  },

  events: {
    ko: {
      title: '행사 / 일정',
      sections: [
        { heading: '이 화면은 무엇인가요', body: '교회 행사와 일정을 등록·관리하는 화면입니다. 목록 보기와 달력 보기를 전환할 수 있습니다.' },
        { heading: '달력에서 등록·이동', body: '빈 칸을 클릭하면 그 날짜로, 여러 칸을 드래그하면 그 기간으로 새 일정이 등록됩니다. 이미 있는 일정은 드래그해서 날짜를 옮길 수 있습니다(반복 일정은 드래그로 옮길 수 없고, 일정을 열어 "시작" 날짜를 수정해야 합니다). 우클릭하면 복사/붙여넣기도 가능합니다.' },
        { heading: '반복 설정', body: '매주(요일), 매달(몇째 주 무슨 요일), 매년(날짜) 반복을 설정할 수 있고, 반복 종료일을 비워두면 계속 반복됩니다.' },
        { heading: '대표 예배(출석체크) 지정', body: '주일예배 카테고리의 행사는 항상 하나가 "출석체크"로 지정되어 있어야 하며, 이 지정이 출석 체크 화면의 대표 예배와 연동됩니다.' },
        { heading: '행사 클릭 시(상세)', body: '세부 일정 추가, 회의록 작성(파일을 끌어다 놓으면 바로 첨부됨, 참석자 지정), 참가 신청자 명단 관리를 할 수 있습니다.' },
        { heading: '중보기도 릴레이', body: '"+ 중보기도 릴레이" 버튼으로 요일별 릴레이 중보기도 캠페인을 새로 만들 수 있습니다.' },
      ],
    },
    en: {
      title: 'Events',
      sections: [
        { heading: 'What this screen is', body: 'Register and manage church events and schedules. Switch between list view and calendar view.' },
        { heading: 'Register or move on the calendar', body: 'Click an empty day to create an event on that date, or drag across several days to set a date range. Existing events can be dragged to a new date (recurring events can\'t be dragged — open the event and change its "start" date instead). Right-click for copy/paste.' },
        { heading: 'Recurrence', body: 'Set events to repeat weekly (by weekday), monthly (by nth weekday), or yearly (by date). Leave the end date blank to repeat indefinitely.' },
        { heading: 'Primary service designation', body: 'Sunday-service events must always have exactly one marked as the "primary service" — this links to the primary service on the Attendance screen.' },
        { heading: 'Clicking an event (detail)', body: 'Add sub-schedules, write meeting minutes (drop a file anywhere in the box to attach it, and assign attendees), and manage the list of registered participants.' },
        { heading: 'Prayer relay', body: 'Use the "+ Prayer Relay" button to start a new day-by-day intercessory prayer relay campaign.' },
      ],
    },
  },

  eventDetail: {
    ko: {
      title: '행사 상세',
      sections: [
        { heading: '이 화면은 무엇인가요', body: '행사/일정 화면에서 특정 행사를 클릭했을 때 열리는 상세 화면입니다.' },
        { heading: '세부 일정', body: '큰 행사(수련회 등) 안의 세부 프로그램을 시간/장소와 함께 등록·수정·삭제할 수 있습니다.' },
        { heading: '회의록', body: '행사와 관련된 회의록을 작성·보관합니다. 내용 입력 상자 어디에나 파일을 끌어다 놓으면 첨부되고, 참석자를 그룹 멤버 중에서 선택할 수 있습니다.' },
        { heading: '참가 신청', body: '교인 이름으로 검색해서 참가자를 추가하거나, 신청을 취소할 수 있습니다.' },
      ],
    },
    en: {
      title: 'Event Detail',
      sections: [
        { heading: 'What this screen is', body: 'Opens when you click a specific event from the Events screen.' },
        { heading: 'Sub-schedules', body: 'Register, edit, or delete the detailed program items (with time and location) inside a larger event like a retreat.' },
        { heading: 'Meeting minutes', body: 'Write and keep minutes related to this event. Drop a file anywhere in the content box to attach it, and pick attendees from group members.' },
        { heading: 'Registration', body: 'Search by member name to add participants, or cancel a registration.' },
      ],
    },
  },

  finance: {
    ko: {
      title: '헌금 / 재정',
      sections: [
        { heading: '이 화면은 무엇인가요', body: '헌금·예산·지출·영수증 발급 등 교회 재정 전반을 다루는 화면입니다. 계정 권한에 따라 볼 수 있는 탭이 다르며, 조회 전용 계정에는 안내 문구가 표시됩니다.' },
        { heading: '헌금 입금', body: '"빠른 입력"(표 형태로 이름·금액을 연달아 입력, 또는 엑셀에서 여러 줄을 붙여넣기)과 "목록" 보기를 전환할 수 있고, 엑셀 일괄 등록/내보내기도 지원합니다. 이름이 일치하는 교인이 없으면 "미등록"으로 저장되고 나중에 연결할 수 있습니다.' },
        { heading: '통계', body: '월별/유형별/연도별 헌금 통계와 "헌금 종류별 주간 통계" 표를 볼 수 있습니다. 표의 각 숫자(칸/행합계/열합계/총합계)를 클릭하면 그 범위에 해당하는 상세 내역이 이동 가능한 창으로 열립니다.' },
        { heading: '예산', body: '연도별 예산을 분류·항목 단위로 편성합니다. "새해 예산 세우기" 마법사로 전년도 예산을 불러와 항목별 증액/감액을 적용해 새 예산을 만들 수 있고, 분류별·항목별 도넛 차트의 조각을 클릭하면 예산액/집행액/잔액/집행률이 담긴 상세 창이 열립니다.' },
        { heading: '지출 / 관리비', body: '지출 탭에서 지출을 등록(빠른 입력 가능)하고 예산 항목과 연결합니다. 관리비 탭에서는 매달/매년 반복되는 관리비 항목을 등록해 납부 처리하고, 예상 금액을 실제 예산에 반영하거나 예상 대비 실제 납부를 비교할 수 있습니다.' },
        { heading: '영수증(CRA) / 결의서', body: '영수증 탭에서 연도별 세금환급 영수증을 일괄 발급하고 PDF/ZIP으로 내려받습니다. 결의서 탭에서는 월간/주간 수입·지출 결의서를 인쇄하거나 PDF로 저장할 수 있고, 항목을 클릭하면 상세 내역이 열립니다.' },
        { heading: '개인별 조회', body: '교인 이름으로 검색해 그 교인(및 가족 합산)의 연간 헌금 내역과 건수를 조회합니다.' },
      ],
    },
    en: {
      title: 'Finance',
      sections: [
        { heading: 'What this screen is', body: 'Covers church finances broadly: offerings, budget, expenditures, and receipts. Which tabs you see depends on your account\'s permissions, and view-only accounts see a notice saying so.' },
        { heading: 'Offerings', body: 'Switch between "Quick Entry" (a grid for typing name/amount in a row, or pasting several rows from Excel) and "List" view; bulk Excel import/export is also supported. If a name doesn\'t match any member, it\'s saved as "unlinked" and can be linked to a member later.' },
        { heading: 'Statistics', body: 'View giving statistics by month, type, and year, plus a "Weekly Statistics by Offering Type" table. Click any number in that table (a cell, a row total, a column total, or the grand total) to open a movable window with the matching detail records.' },
        { heading: 'Budget', body: 'Build the annual budget by category and line item. The "Build Next Year\'s Budget" wizard pulls last year\'s budget so you can apply increases/decreases per item; clicking a slice of the by-category or by-item donut chart opens a detail window showing budgeted/spent/remaining/execution rate.' },
        { heading: 'Expenditures / recurring bills', body: 'The Expenditures tab registers expenses (quick entry available) and links them to budget items. The Bills tab registers monthly/yearly recurring bills, processes payments, reflects expected amounts into the actual budget, and compares expected vs. actual payments.' },
        { heading: 'Receipts (CRA) / statements', body: 'The Receipts tab bulk-issues annual tax receipts and downloads them as PDF/ZIP. The Statements tab prints or saves monthly/weekly income & expense statements as PDF; clicking a line item opens its detail.' },
        { heading: 'Per-member lookup', body: 'Search by member name to see that member\'s (and their family\'s combined) annual giving history and count.' },
      ],
    },
  },

  pastoral: {
    ko: {
      title: '목회 관리',
      sections: [
        { heading: '이 화면은 무엇인가요', body: '심방 기록·미출석 교인·기도제목을 통합 관리하는 화면입니다. 심방기록과 기도제목에는 교인 개인정보가 담겨 있어, 화면에 들어가려면 먼저 "금고"를 비밀번호 + 등록된 보안키(지문/보안키)로 잠금해제해야 합니다.' },
        { heading: '심방 기록', body: '"심방 등록"으로 교인·날짜·유형(가정방문/전화심방/병원 등)·내용·다음 심방 예정일을 기록합니다. 교인명/내용 검색, 유형·담당자·기간 필터, 인쇄를 지원합니다.' },
        { heading: '미출석 교인', body: '출석 기준(몇 주/개월 이상 미출석) 또는 헌금 기준(올해 헌금 횟수가 기준보다 적은 교인)으로 안부가 필요한 교인을 찾아, 그 자리에서 바로 심방을 등록할 수 있습니다.' },
        { heading: '기도제목', body: '공동 기도제목과 개인 기도제목을 구분해 등록하고, 카테고리를 분류하며, 응답 여부와 응답 내용을 표시할 수 있습니다.' },
        { heading: '금고 관리', body: '우측 상단 버튼으로 잠금/잠금해제 상태 확인, 비밀번호 변경, 내용까지 암호화할지(화면 잠금만 할지) 모드 전환, 접근 로그 확인을 할 수 있습니다.' },
      ],
    },
    en: {
      title: 'Pastoral Care',
      sections: [
        { heading: 'What this screen is', body: 'Manages pastoral visits, members who haven\'t attended recently, and prayer requests together. Because visit records and prayer requests contain personal information, you must unlock the "vault" (passphrase + a registered security key) before you can enter this screen.' },
        { heading: 'Visit records', body: 'Use "Register Visit" to log the member, date, type (home visit, phone, hospital, etc.), content, and next planned visit date. You can search by member name/content and filter by type, assignee, or date range, and print the list.' },
        { heading: 'Members who haven\'t attended', body: 'Find members who need a check-in, either by attendance (absent for X weeks/months or more) or by giving (fewer offerings than a threshold this year), and register a visit for them right from this list.' },
        { heading: 'Prayer requests', body: 'Register public (shared) or private prayer requests, categorize them, and mark whether — and how — they were answered.' },
        { heading: 'Vault management', body: 'The buttons at the top right let you check the lock state, change the vault passphrase, switch between encrypting content vs. screen-lock-only mode, and view the vault access log.' },
      ],
    },
  },

  meetingMinutes: {
    ko: {
      title: '회의록',
      sections: [
        { heading: '이 화면은 무엇인가요', body: '제직회·당회 등 회의록을 작성하고 보관하는 화면입니다. 사역 진영과 재정 진영이 함께 쓰지만, 각자 자기 진영의 회의 종류만 보입니다.' },
        { heading: '작성', body: '제목·날짜/시간·소요시간·회의 종류·참석자(회의 종류가 조직의 그룹과 연결돼 있으면 그룹 멤버를 체크박스로 선택 가능)·내용을 입력합니다. 내용 입력 상자 어디에나 파일을 끌어다 놓으면 첨부됩니다(파일당 용량/개수 제한 있음).' },
        { heading: '검색', body: '제목·내용뿐 아니라 첨부된 PDF·워드·텍스트 파일의 내용까지 함께 검색됩니다(한글 HWP·이미지·엑셀/파워포인트는 아직 지원하지 않습니다).' },
        { heading: '삭제 안전장치', body: '목록에서 "삭제 허용"을 체크해야 그 줄의 삭제 버튼이 활성화됩니다 — 실수로 지우는 것을 막기 위한 장치입니다.' },
        { heading: '회의 종류 관리', body: '"회의 종류 관리"에서 종류를 추가/삭제하고, 조직 메뉴의 그룹과 연결해두면 참석자를 더 쉽게 고를 수 있습니다.' },
      ],
    },
    en: {
      title: 'Meeting Minutes',
      sections: [
        { heading: 'What this screen is', body: 'Write and keep minutes for meetings such as the board or session. Both the pastoral and finance sides use this screen, but each only sees its own meeting types.' },
        { heading: 'Writing minutes', body: 'Enter the title, date/time, duration, meeting type, attendees (if the meeting type is linked to an organization group, you can check off group members), and content. Drop a file anywhere in the content box to attach it (per-file size/count limits apply).' },
        { heading: 'Search', body: 'Search covers not just the title and content but also the text inside attached PDF, Word, and plain-text files (Korean HWP, images, and Excel/PowerPoint aren\'t supported yet).' },
        { heading: 'Delete safeguard', body: 'Check "Allow Delete" in the list before a row\'s delete button becomes active — a safeguard against accidental deletion.' },
        { heading: 'Managing meeting types', body: '"Manage Meeting Types" lets you add/remove types; linking a type to an organization group makes picking attendees easier.' },
      ],
    },
  },

  committee: {
    ko: {
      title: '제직회',
      sections: [
        { heading: '이 화면은 무엇인가요', body: '제직회 산하 부서(관리부·선교부 등)별 업무를 다루는 화면입니다. 부서마다 비품관리대장, 선교 프로젝트, 게시판(준비중) 중 필요한 기능이 연결됩니다.' },
        { heading: '비품관리대장', body: '현황/목록/등록/QR라벨/이력/설정 탭으로 구성됩니다. 품목을 등록(수량·보관장소·분류·구입가 등)하고, 엑셀에서 여러 줄을 붙여넣어 한 번에 등록할 수도 있습니다. QR 라벨을 인쇄해 물품에 붙이면, 스캔으로 바로 상세정보를 열거나 "제자리"를 벗어난 품목을 추적할 수 있습니다. 모든 등록/수정/폐기/조사 이력이 남습니다.' },
        { heading: '선교 프로젝트', body: '해외/국내 선교 프로젝트를 등록하고 계획/진행중/완료 상태와 담당자, 진행 내용을 관리합니다.' },
        { heading: '부서 관리', body: '"부서 관리"에서 새 부서를 추가하거나 기존 부서를 목록에서 숨길 수 있습니다(데이터는 남습니다).' },
      ],
    },
    en: {
      title: 'Committee',
      sections: [
        { heading: 'What this screen is', body: 'Handles work by department under the church board — such as facilities or missions. Each department connects to whichever tools it needs: an equipment register, mission projects, or a bulletin board (coming soon).' },
        { heading: 'Equipment register', body: 'Has Dashboard / List / Add / QR Labels / History / Settings tabs. Register items (quantity, storage location, category, purchase price, etc.), or bulk-register by pasting several rows from Excel. Print QR labels and attach them to items so you can scan straight to an item\'s detail, or track items that have strayed from their assigned "home" location. Every add/edit/dispose/audit action is logged.' },
        { heading: 'Mission projects', body: 'Register overseas/domestic mission projects and track status (planned/in progress/completed), the person in charge, and progress notes.' },
        { heading: 'Managing departments', body: '"Manage Departments" lets you add a new department or hide an existing one from the list (its data is kept).' },
      ],
    },
  },

  committeeEquipmentScan: {
    ko: {
      title: '비품 QR 스캔',
      sections: [
        { heading: '이 화면은 무엇인가요', body: '비품에 붙은 QR 라벨을 스캔했을 때 열리는 화면으로, 스캔한 그 비품의 상세정보(제자리 여부 포함)를 바로 보여줍니다. 보통 스마트폰 카메라나 QR 스캐너 앱으로 접속합니다.' },
        { heading: '돌아가기', body: '화면 하단의 "제직회로 돌아가기"로 제직회 메인 화면으로 이동할 수 있습니다.' },
      ],
    },
    en: {
      title: 'Equipment QR Scan',
      sections: [
        { heading: 'What this screen is', body: 'Opens when you scan an item\'s QR label — usually with a phone camera or QR scanner app — and shows that item\'s details right away, including whether it\'s in its assigned home location.' },
        { heading: 'Going back', body: 'Use "Back to Committee" at the bottom to return to the Committee main screen.' },
      ],
    },
  },

  committeeLocationScan: {
    ko: {
      title: '장소 QR 스캔',
      sections: [
        { heading: '이 화면은 무엇인가요', body: '보관장소에 붙은 QR 라벨을 스캔했을 때 열리는 화면입니다. 그 장소를 "제자리"로 등록된 품목 목록과, 원래 다른 곳이 제자리인데 지금 여기 있는("제자리 이탈") 품목 목록을 함께 보여줍니다.' },
        { heading: '참고', body: '장소 QR코드는 한 번 발급하면 나중에 장소 이름이 바뀌어도 코드 자체는 그대로 재사용됩니다.' },
      ],
    },
    en: {
      title: 'Location QR Scan',
      sections: [
        { heading: 'What this screen is', body: 'Opens when you scan a location\'s QR label. It shows the items whose home is this location, along with any items that belong elsewhere but are currently here ("strayed").' },
        { heading: 'Note', body: 'Once a location\'s QR code is issued, it keeps working even if you later rename the location.' },
      ],
    },
  },

  prayerRelay: {
    ko: {
      title: '중보기도 릴레이',
      sections: [
        { heading: '이 화면은 무엇인가요', body: '요일별로 성도들이 돌아가며 기도 시간을 맡는 "릴레이 중보기도" 캠페인을 만들고 관리하는 화면입니다. 성도는 모바일 포털에서 원하는 요일/시간대에 참여를 등록합니다.' },
        { heading: '캠페인 만들기', body: '"새 캠페인"으로 이름·설명·기간·진행 요일·매일 시작/종료 시각·시간 단위(분)·알림을 몇 분 전에 보낼지를 설정합니다.' },
        { heading: '기도제목', body: '캠페인에 기도제목을 등록하면 참여자에게 가는 알림 이메일에 그대로 포함됩니다. 응답된 기도제목은 표시해둘 수 있고, 비활성화하면 이력은 남되 더 이상 알림에는 포함되지 않습니다.' },
        { heading: '등록 현황', body: '성도들이 등록한 요일/시간별 참여 현황을 확인합니다. 빈자리를 클릭하면 관리자가 대신 등록해줄 수 있고(매주 반복 또는 이번 한 번만 선택 가능), 관리자가 대신 등록한 자리에는 배지가 표시됩니다.' },
      ],
    },
    en: {
      title: 'Prayer Relay',
      sections: [
        { heading: 'What this screen is', body: 'Create and manage "relay" intercessory prayer campaigns, where members take turns praying on a day/time schedule. Members sign up for a day/time slot from their mobile portal.' },
        { heading: 'Creating a campaign', body: 'Use "New Campaign" to set the name, description, date range, active weekdays, daily start/end time, time-slot length (minutes), and how many minutes before a slot to send a reminder.' },
        { heading: 'Prayer topics', body: 'Topics added to a campaign are included as-is in the reminder emails sent to participants. Mark a topic as answered, or deactivate it to keep its history without including it in future reminders.' },
        { heading: 'Sign-up roster', body: 'See who has signed up for which day/time slot. Click an empty slot to register someone on their behalf (as a weekly recurring slot or a one-time slot) — admin-added slots are marked with a badge.' },
      ],
    },
  },

  codeSettings: {
    ko: {
      title: '시스템 설정',
      sections: [
        { heading: '이 화면은 무엇인가요', body: '교회 운영에 필요한 각종 기준값을 관리자가 직접 설정하는 화면입니다. 왼쪽(또는 상단) 탭으로 세부 설정 항목을 전환합니다.' },
        { heading: '주요 탭', body: '코드 설정(신앙이력·연락처 종류·예배종류 등), 그룹 유형(셀·구역·목장), 직분, 봉사부서, 행사 카테고리, 예배 자동 등록(행사/일정의 예배를 출석관리에 자동 반영), 재정 설정(CRA 등록번호·서명자·영수증 문구), 메뉴 권한(역할별로 보일 메뉴), 화면 표시(교인 상세정보에 표시할 항목), 이메일 발송 설정(어린이 체크인 안내용 Gmail 계정)으로 구성됩니다.' },
        { heading: '메뉴 권한', body: '목회자/리더 역할에게 보일 메뉴를 여기서 켜고 끌 수 있습니다. 다만 재정(헌금/재정) 메뉴는 사역 진영에게 절대 노출되지 않도록, 시스템 설정·사용자 관리는 항상 관리자 전용으로 코드에 고정되어 있어 이 화면에서도 바꿀 수 없습니다.' },
        { heading: '변경 이력', body: '"변경 이력" 탭에서 이 화면의 모든 설정 변경 기록을 확인할 수 있고, 잘못 바꾼 경우 "되돌리기"로 바로 이전 값으로 복구할 수 있습니다.' },
      ],
    },
    en: {
      title: 'System Settings',
      sections: [
        { heading: 'What this screen is', body: 'Where administrators configure the reference values the church runs on. Switch between sub-settings using the tabs.' },
        { heading: 'Main tabs', body: 'Codes (faith-history types, contact types, service types, etc.), Group Types (cell/district/pasture), Positions, Ministry Departments, Event Categories, Auto-register Services (reflect Events\' worship schedule into Attendance), Finance Settings (CRA registration number, signer, receipt footer), Menu Permissions (which menus each role sees), Display (which fields show on member detail), and Check-in Email Settings (the Gmail account used for child check-in notices).' },
        { heading: 'Menu permissions', body: 'Toggle which menus are visible to pastors/leaders. The Finance menu is never exposed to the pastoral side, and System Settings/User Management are always admin-only — both are fixed in code and can\'t be changed here.' },
        { heading: 'Change history', body: 'The "Change History" tab logs every setting change made on this screen; if something was changed by mistake, "Undo" restores the previous value immediately.' },
      ],
    },
  },

  cardScan: {
    ko: {
      title: '카드 인식',
      sections: [
        { heading: '이 화면은 무엇인가요', body: '어르신 등 온라인 등록이 어려운 분이 작성한 종이 등록카드를 사진으로 찍으면, AI가 내용을 자동으로 읽어주는 화면입니다.' },
        { heading: '사용법', body: '① 카메라로 찍거나 파일을 선택 → ② "AI로 자동 인식" → ③ 인식된 이름·연락처·생년월일·가족관계 등을 확인하고 잘못된 부분만 고침 → ④ "대기 목록에 저장". 저장된 내용은 "등록 신청 관리" 화면에서 검토 후 승인해야 실제 교인으로 등록됩니다.' },
      ],
    },
    en: {
      title: 'Card Scan',
      sections: [
        { heading: 'What this screen is', body: 'For members who filled out a paper registration card instead of registering online (often older members) — take a photo of the card and AI reads it automatically.' },
        { heading: 'How to use it', body: '① Take a photo or choose a file → ② "Auto-recognize with AI" → ③ Review the recognized name, contact, birth date, family relationships, etc., and correct anything wrong → ④ "Save to pending list." Saved entries then need to be reviewed and approved on the "Pending Registrations" screen before they become actual members.' },
      ],
    },
  },

  pendingRegistrations: {
    ko: {
      title: '등록 신청 관리',
      sections: [
        { heading: '이 화면은 무엇인가요', body: '모바일 등록 폼, 카드 인식, 새가족일지 일괄 등록으로 접수된 신청을 검토·승인·반려하는 화면입니다.' },
        { heading: '탭', body: '대기중 / 승인됨 / 반려됨 세 탭으로 구분됩니다.' },
        { heading: '검토', body: '접수된 내용(이름·연락처·주소·신앙경력 등)을 확인하고 필요하면 직접 수정한 뒤 "기존 교인 업데이트"(이미 등록된 교인과 매칭) 또는 "신규 교인 등록"으로 처리합니다. 검토 메모를 남길 수 있고, 수정한 내용은 승인/반려 전에 먼저 저장해야 합니다.' },
      ],
    },
    en: {
      title: 'Pending Registrations',
      sections: [
        { heading: 'What this screen is', body: 'Review, approve, or reject registrations submitted via the mobile form, card scan, or a bulk new-member import.' },
        { heading: 'Tabs', body: 'Three tabs: Pending / Approved / Rejected.' },
        { heading: 'Reviewing', body: 'Check the submitted details (name, contact, address, faith history, etc.), edit them if needed, then process as "Update Existing Member" (match to an already-registered member) or "Register as New Member." You can leave a review note, and any edits must be saved before you approve or reject.' },
      ],
    },
  },

  qrCode: {
    ko: {
      title: '등록 QR코드',
      sections: [
        { heading: '이 화면은 무엇인가요', body: '새신자가 스마트폰으로 스캔해 온라인 등록 폼을 열 수 있는 QR코드/링크를 관리하고, 인쇄용 안내물을 만드는 화면입니다.' },
        { heading: '설정', body: 'QR 링크에 쓰일 짧은 코드(slug, 영문 소문자·숫자·하이픈만 가능)와, 성도들이 홈 화면에 추가했을 때 보일 교회 아이콘(파비콘)을 설정합니다.' },
        { heading: '사용 흐름', body: '① 입구·안내데스크·주보에 QR코드를 비치 → ② 새신자가 스캔하면 등록 폼이 열림 → ③ 어르신 등은 종이 등록카드를 작성하면 담당자가 "카드 인식" 화면으로 대신 입력 → ④ 접수된 신청은 "등록 신청 관리"에서 검토 후 승인.' },
        { heading: '인쇄', body: '화면 하단에서 QR코드를 바로 인쇄하거나 이미지로 저장할 수 있습니다.' },
      ],
    },
    en: {
      title: 'Registration QR Code',
      sections: [
        { heading: 'What this screen is', body: 'Manage the QR code/link that new visitors scan to open the online registration form, and generate printable signage for it.' },
        { heading: 'Settings', body: 'Set the short code (slug — lowercase letters, digits, and hyphens only) used in the QR link, and the church icon (favicon) shown when members add the portal to their home screen.' },
        { heading: 'How it flows', body: '① Place the QR code at the entrance, welcome desk, or in the bulletin → ② new visitors scan it to open the registration form → ③ older visitors who fill out a paper card instead have it entered by staff via "Card Scan" → ④ submitted registrations are reviewed and approved on "Pending Registrations."' },
        { heading: 'Printing', body: 'Print the QR code directly from this screen, or save it as an image.' },
      ],
    },
  },

  checkin: {
    ko: {
      title: '어린이 체크인',
      sections: [
        { heading: '이 화면은 무엇인가요', body: '예배·주일학교 시간에 자녀를 맡기고(체크인) 찾아갈 때(체크아웃) 사용하는 화면입니다. 보호자 QR 스캔 → 자녀 선택 → 체크인 → 픽업코드 발급의 흐름으로 동작합니다.' },
        { heading: '체크인', body: 'QR 스캔 모드에서 보호자 QR을 스캔하거나 토큰을 입력해 조회한 뒤 자녀를 선택해 체크인합니다. 보호자 QR이 없으면 "대행 체크인"으로 선생님이 대신 처리할 수 있으며, 이 경우 감사 로그에 기록됩니다. 체크인 완료 후 명찰을 인쇄하거나 보호자에게 링크를 보낼 수 있습니다.' },
        { heading: '처음 오신 경우(워크인)', body: '"처음 오셨어요" 버튼으로 보호자·자녀 정보를 그 자리에서 입력하면, 신규 등록과 동시에 바로 체크인됩니다.' },
        { heading: '오늘 현황', body: '현재 위탁 중인 아이들과 오늘 체크인/체크아웃 기록을 확인합니다. QR·픽업코드·대행 방식으로 체크아웃 처리하고, 필요하면 체크인 취소(사유 입력)나 체크아웃 취소도 할 수 있습니다.' },
        { heading: '이메일 안내', body: '보호자에게 체크인/체크아웃 안내 이메일을 보내거나 재전송할 수 있습니다(발신 Gmail 계정은 시스템 설정에서 미리 등록해야 합니다).' },
      ],
    },
    en: {
      title: 'Kids Check-in',
      sections: [
        { heading: 'What this screen is', body: 'Used to check children in and out during worship/Sunday school. Flow: scan the guardian\'s QR → pick the child/children → check in → pickup code is issued.' },
        { heading: 'Checking in', body: 'In QR scan mode, scan the guardian\'s QR (or type in a token) to look them up, then select which children to check in. If there\'s no guardian QR, a staff member can use "Staff Check-in" instead (this is recorded in the audit log). After checking in, you can print a name badge or copy a link to send the guardian.' },
        { heading: 'First-time visitors (walk-in)', body: 'Use "First time here?" to enter guardian and child details on the spot — this registers them and checks them in at the same time.' },
        { heading: 'Today\'s status', body: 'See who\'s currently checked in and today\'s check-in/check-out records. Check out via QR, pickup code, or staff override, and cancel a check-in (with a reason) or undo a check-out if needed.' },
        { heading: 'Email notices', body: 'Send or resend a check-in/check-out notice email to the guardian (the sending Gmail account must first be set up in System Settings).' },
      ],
    },
  },

  users: {
    ko: {
      title: '사용자 관리',
      sections: [
        { heading: '이 화면은 무엇인가요', body: '이 시스템에 로그인하는 계정(사용자)을 관리하는 화면입니다. "사용자 목록"과 "메뉴/권한 관리" 두 탭으로 구성됩니다.' },
        { heading: '사용자 목록', body: '"+ 사용자 추가"로 이메일·이름·역할(겸임 역할도 선택 가능)을 입력해 계정을 만들면 임시 비밀번호가 자동 생성되어 화면에 표시됩니다. 목록에서 비밀번호 재설정, 담당그룹 지정(리더는 담당 그룹의 소그룹/출석 데이터만 볼 수 있음), 비활성화/재활성화를 할 수 있습니다.' },
        { heading: '메뉴/권한 관리', body: '안수집사/제직 역할이 헌금·재정 화면에서 볼 수 있는 탭(통계/예산/지출)과, 회의록 종류별 접근 권한(없음/보기/전체)을 설정합니다. 재정 관리자(재정 관리자·집사 관리자·헌금/재정 담당)는 이 설정과 무관하게 항상 전체 화면을 볼 수 있습니다.' },
      ],
    },
    en: {
      title: 'Users',
      sections: [
        { heading: 'What this screen is', body: 'Manage the login accounts (users) for this system. Two tabs: "User List" and "Menu/Permission Management."' },
        { heading: 'User list', body: 'Use "+ Add User" to enter an email, name, and role (with optional additional roles) — a temporary password is generated automatically and shown on screen. From the list you can reset a password, assign a leader\'s groups (leaders only see data for their assigned groups), and deactivate/reactivate accounts.' },
        { heading: 'Menu/permission management', body: 'Set which Finance tabs (Statistics/Budget/Expenditures) deacon/elder roles can see, and their access level per meeting-minutes type (none/view/full). Finance admins (finance admin, elder admin, offering/finance staff) always see everything regardless of this setting.' },
      ],
    },
  },
};

// pathname과 언어에 맞는 콘텐츠를 찾는다. 매칭되는 게 없으면 null.
// en이 아직 없는 항목은 자동으로 ko로 대체된다(지금은 모든 항목에 en이 있음).
export function getHelpContent(pathname, lang) {
  const route = ROUTES.find((r) => r.re.test(pathname));
  if (!route) return null;
  const entry = CONTENT[route.key];
  if (!entry) return null;
  return (lang === 'en' ? entry.en : entry.ko) || entry.ko || entry.en || null;
}
